import React, { useEffect, useMemo, useState } from "react";
import Selection from "./Sections/Selection";
import { deployTokenStyles as styles } from "./deployToken.tailwind";
import { useSelector } from "react-redux";
import { getFilteredPlayerAndActions } from "./deployToken.data";

const PlayerAndActionSection = ({
  currentStep,
  tokenData,
  selectedTokenId,
  setSelectedTokenId,
  handleImageSelect,
  handleNextStep,
  handleBackStep,
  isDeployed,
  tokensLength,
  isEditingCurrentToken
}) => {
  // Get Current Season Details
  const { currentSeason } = useSelector((state) => state.seasons);
  const { deployTokenLoading } = useSelector((state) => state.deployToken);
  const actions = currentSeason?.actions;               // get current season actions
  const players = currentSeason?.homeTeam?.players;     // get current season players
  const { players: playerImages, actions: actionImages } = getFilteredPlayerAndActions({ players, actions }) // Filtered Actions and Players

  const [disableButton, setDisableButton] = useState(false);

  // selected player image
  const selectedPlayerImage = useMemo(() => {
    return tokenData.find((token) => token.tokenIndex === selectedTokenId)?.selectedImages?.playerImage;
  }, [tokenData, selectedTokenId]);

  // selected action image
  const selectedActionImage = useMemo(() => {
    return tokenData.find((token) => token.tokenIndex === selectedTokenId)?.selectedImages?.actionImage;
  }, [tokenData, selectedTokenId]);
 
  const handleNextTokenSelect = async() => {
    if(isEditingCurrentToken){
      await handleNextStep();
      return;
    }

    if (isDeployed && (selectedTokenId < (tokensLength - 1))) {
      setSelectedTokenId(selectedTokenId + 1);
      return;
    }
    
    if(!isDeployed) {
      handleNextStep(); // Proceed to the next step if not deployed
    }
  };

  // Disable the next button if the selected token is the last one
  useEffect(() => {
    if(isEditingCurrentToken) {
      setDisableButton(false);
      return;
    }
    if (selectedTokenId >= tokensLength - 1 && isDeployed && currentStep === 2) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [selectedTokenId, tokensLength, isDeployed, isEditingCurrentToken, currentStep]);
  

  return (
    <div className={styles.rowContainer}>
      {/* Step 1: Choose Player Image */}
      {currentStep === 1 && players && (
        <Selection
          stepNumber="Step 1"           // step number
          heading="Select Your Player"  // step heading
          images={playerImages}         // player images
          selectedImage={selectedPlayerImage}  // selected player image
          onImageSelect={(image) => handleImageSelect(image, "playerImage")}            // handle image select action
          buttonText={
            (isDeployed && deployTokenLoading && isEditingCurrentToken) ? "Updating..." 
            : (isDeployed && isEditingCurrentToken) ? "Update & Next" 
            : "Next" 
          }  // button text
          onNext={handleNextStep}       // handle next step
          onBack={handleBackStep}       // handle back step
          isDisabled={disableButton || deployTokenLoading}    // button to be disabled if the token is deployed or the token is last and deployed
        />
      )}

      {/* Step 2: Choose Action Image */}
      {currentStep === 2 && actions && (
        <Selection
          stepNumber="Step 2"            // step number
          heading="Select Your Action"   // step heading
          images={actionImages}          // action images
          selectedImage={selectedActionImage}   // selected action image
          onImageSelect={(image) => handleImageSelect(image, "actionImage")} // handle image select action
          buttonText={
            (isDeployed && deployTokenLoading  && isEditingCurrentToken) ? "Updating..." 
            : (!isDeployed && deployTokenLoading) ? "Powering-Up"
            : (isDeployed && !isEditingCurrentToken) ? "Next"
            : (isDeployed && isEditingCurrentToken) ? "Update"
            : "Power-Up" 
          }  // button text depend on isDeployed or not
          onNext={handleNextTokenSelect}   // handle next step
          onBack={handleBackStep}          // handle back step
          isDisabled={disableButton || deployTokenLoading}   //button to be disabled if the token is deployed or the token is last and deployed
          isDeployed={isDeployed}          // to check if deployed
        />
      )}
    </div>
  );
};

export default PlayerAndActionSection;